// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const categoriesList = "CategoriesList__categoriesList__SsbUz";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const item = "CategoriesList__item__oE73H";
export const itemPoint = "CategoriesList__itemPoint__Oh2ga";
export const itemText = "CategoriesList__itemText__UTxtl font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const shaded = "CategoriesList__shaded__kDDCa";